/* Helpers extracted from step1 for reuse and testing */
import { FormularioComunidades } from 'interfaces/formularioComunidades.interface';

export const generateUniqueId = () => {
  try {
    // prefer Web Crypto when available
    // @ts-ignore
    if (typeof globalThis !== 'undefined' && (globalThis as any).crypto && (globalThis as any).crypto.randomUUID) {
      // @ts-ignore
      return (globalThis as any).crypto.randomUUID();
    }
  } catch (e) {
    // ignore
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
};

export const mapAssentamentoToForm = (src: any): Partial<FormularioComunidades> => ({
  unique_id: src?.unique_id ?? generateUniqueId(),
  step_atual: 1,
  ano_referencia: 2025 as any,
  tipo_cadastro: 1,
  tipo_de_assentamento: src?.tipo_de_assentamento ?? null,
  codigo_do_pa: src?.codigo_do_pa
    ? String(src.codigo_do_pa).slice(0, 9)
    : '',
  nome_do_assentamento: src?.nome_do_assentamento ?? '',
  quantidade_de_familias: src?.quantidade_de_familias ?? null,
});

export const mapComunidadeToForm = (src: any): Partial<FormularioComunidades> => ({
  unique_id: src?.unique_id ?? generateUniqueId(),
  step_atual: 1,
  ano_referencia: 2025 as any,
  tipo_cadastro: 2,
  tipo_de_assentamento: null,
  codigo_do_pa: '',
  nome_do_assentamento: src?.nome ?? src?.name ?? src?.nome_do_assentamento ?? '',
  quantidade_de_familias:
    src?.quantidade_familias ?? src?.qtdFamilias ?? src?.quantidade_de_familias ?? null,
});
